import cmsSettings from '../cmsSettings'
import pressHighlight from '../pressHighlight'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  'items': *[_type == "pressHighlight" && $language in enabledRegions] | order(content.i18n[$language].publishedDate desc, content.i18n.en_us.publishedDate desc) {
    ${pressHighlight.fields}
  }[0...8]
`

export const fragment = (name = 'pressHighlightListing') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
